<template>
  <div
    v-if="isVisible"
    class="
      tw-fixed
      tw-bottom-4
      tw-left-1/2
      tw--translate-x-1/2
      tw-bg-black
      tw-text-white
      tw-flex
      tw-items-center
      tw-justify-between
      tw-px-2
      tw-py-1
      tw-rounded-lg
      tw-gap-3
      tw-border
      tw-border-sf-gray-darker
      tw-shadow-md
      tw-transition-all
      tw-duration-500
      tw-ease-out
    "
    :class="{
      'tw-translate-y-full tw-opacity-0': !showBanner,
      'tw-translate-y-0 tw-opacity-100': showBanner,
    }"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <SfButtonDs
        variant="secondary"
        size="sm"
        icon-before="arrow-left"
        data-heap="back-in-context"
        @click="goBackToContext"
      >
        {{ I18n.t(`shared.back_in_context.${backInContextType}`) }}
      </SfButtonDs>
      <span class="tw-text-sm">{{ titleText }}</span>
      <button
        class="
          tw-bg-transparent
          tw-text-sf-snow-light
          tw-text-xl
          tw-border-none
          tw-text-[16px]
        "
        @click.prevent.stop="closeBanner"
      >
        <i class="fa fa-close" />
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useNavigationStore } from '@app/shared/vue/store/navigation-store'
import { SfButtonDs } from '@silverfin/ui-components'

const I18n = useI18n()
const navigationStore = useNavigationStore()
const {
  shouldLoadBackInContext: isVisible,
  backInContextUrl,
  backInContextType,
  viewingItem,
} = storeToRefs(navigationStore)

const showBanner = ref(false)

function goBackToContext() {
  if (backInContextUrl.value) {
    window.Turbolinks.visit(backInContextUrl.value)
  }
}

const titleText = computed(() => {
  switch (backInContextType.value) {
    case 'remark_tag':
      return I18n.t('shared.back_in_context.viewing_in_client_meeting')
    default:
      return I18n.t(`shared.back_in_context.title.${viewingItem.value}`)
  }
})

function closeBanner() {
  navigationStore.clearData()
}

onUnmounted(() => {
  document.removeEventListener('turbolinks:before-visit', closeBanner)
})

onMounted(() => {
  // before-visit fires inside Turbolinks.visit(), before call sites arm the
  // banner; the page-teardown events fire after arming and would wipe it.
  document.addEventListener('turbolinks:before-visit', closeBanner)

  navigationStore.registerForUrl(
    window.location.pathname + window.location.search
  )

  watch(
    isVisible,
    (visible) => {
      showBanner.value = false

      if (visible) {
        setTimeout(() => {
          showBanner.value = true
        }, 3000)
      }
    },
    { immediate: true }
  )
})
</script>
